export var BirthdayFieldPolicyEnum;
(function (BirthdayFieldPolicyEnum) {
    BirthdayFieldPolicyEnum["REQUIRED"] = "REQUIRED";
    BirthdayFieldPolicyEnum["OPTIONAL"] = "OPTIONAL";
    BirthdayFieldPolicyEnum["DISABLED"] = "DISABLED";
})(BirthdayFieldPolicyEnum || (BirthdayFieldPolicyEnum = {}));
export const DEFAULT_BIRTHDAY_POLICY = BirthdayFieldPolicyEnum.OPTIONAL;
export const DEFAULT_TIMEZONE = 'America/New_York';
//# sourceMappingURL=merchant.enum.js.map